export default class AppCart {
    constructor () {
        this.init();
    }

    init () {
        let self = this;
        let $cartable = $('[data-toggle=cartable]');

        if ($cartable.length > 0) {
            $cartable.on('click', function (e) {
                e.preventDefault();
                $('.btn.cart-order').addClass('disabled');
                let $button = $(this);
                $.ajax({
                    method: $button.attr('data-method'),
                    url: $button.attr('data-url'),
                    cache: false,
                })
                    .always(function () {
                        self.loadCart();
                    });
            });

            this.loadCart();
        }
    }

    loadCart () {
        let $cart = $('table.cart');
        $.getJSON($cart.attr('data-url'))
            .done(function (response) {
                $cart.find('tbody').html('');
                $('.cart-button.add').removeClass('d-none');
                $('.cart-button.remove').addClass('d-none');

                if (typeof response === 'object') {
                    let $btnCartOrder = $('.btn.cart-order');

                    if (typeof response.content === 'object') {
                        let rows = Object.values(response.content).sort(function (a, b) {
                            return a.id - b.id;
                        });

                        $.each(rows, function () {
                            $('.cart-button.remove[data-cart-id=' + this.id + ']').removeClass('d-none');
                            $('.cart-button.add[data-cart-id=' + this.id + ']').addClass('d-none');

                            $cart.find('tbody').append(Handlebars.templates['customer.cart.table_row'](this));
                        });

                        if (rows.length > 0) {
                            $btnCartOrder.removeClass('disabled');
                        }
                    }

                    if (response.total_price_formatted !== undefined) {
                        $cart.find('.cart-total').text(response.total_price_formatted);
                        $btnCartOrder.find('span').text(response.total_price_formatted);
                    } else {
                        $btnCartOrder.find('span').text($btnCartOrder.find('span').attr('data-zero'));
                    }
                }
            });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/cart.js